module.exports = __webpack_public_path__ + "static/media/background3.e982e631.png";